import axios from 'axios'

//Default values
const state = {}

const mutations = {}

const actions = {
    SAVE_BRAND: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_URL + 'brands', payload)
                .then((res) => {
                    return resolve(res);
                }).catch(error => {
                return reject(error.response.data);
            })
        })
    },
    GET_BRAND: async (context, payload) => {
        return axios.get(process.env.VUE_APP_API_URL + 'brands/' + payload)
            .then((res) => {
                return res.data
            })
    },
    GET_BRANDS: async ({rootState, commit}, payload) => {
        return axios.get(process.env.VUE_APP_API_URL + 'brands', {
            params: rootState.table.table.serverParams
        })
            .then((res) => {
                commit('FETCH_ITEMS', res.data)
            })
    },
    UPDATE_BRAND: async (context, payload) => {
        return axios.put(process.env.VUE_APP_API_URL + 'brands/' + payload.id, payload)
            .then((res) => {
                return res.data
            })
    },
    DELETE_BRAND: async (context, payload) => {
        return axios.delete(process.env.VUE_APP_API_URL + 'brands/' + payload)
            .then((res) => {
                return res.data
            })
    },
    DROPDOWN_BRANDS: async () => {
        return axios.get(process.env.VUE_APP_API_URL + 'brands/dropdown')
            .then((res) => {
                return res.data
            })
    },
}

const getters = {}

export default {
    state,
    mutations,
    actions,
    getters
}
